import axios from 'axios'
import { SERVICES } from '../config'
import {
  IRegisterDeviceRequestParams,
  IRegisterRequestParams,
  ILoginRequestParams,
    IForgotRequestParams,
    IResetRequestParams
} from '../interfaces/api'

const PATH = {
  APP: '/app',
  AUTH: '/auth',
  DEVICE: '/device',
  TOOLS: '/tools',
}

const client = axios.create({
  baseURL: SERVICES.API,
  responseType: 'json',
})

const getHeaders = () => {
  return sessionStorage.getItem('token')
    ? {
        authorization: 'Bearer ' + sessionStorage.getItem('token'),
      }
    : {}
}

const getHeadersRefreshToken = () => {
  return sessionStorage.getItem('refresh_token')
    ? {
        authorization: 'Bearer ' + sessionStorage.getItem('refresh_token'),
      }
    : {}
}

export const getLanguage = async (currentLanguage: string) => {
  return await client
    .request({
      url: `${PATH.APP}/apptext?language=${currentLanguage}`,
      method: 'GET',
      headers: getHeaders(),
    })
    .catch((err) => {
      console.log('err:', err.response)
      return err.response
    })
}

export const updateLanguage = async (deviceId: string, data: object) => {
  return await client
    .request({
      url: `${PATH.DEVICE}/${deviceId}/language`,
      method: 'PUT',
      data,
      headers: getHeaders(),
    })
    .catch((err) => {
      console.log('err:', err.response)
      return err.response
    })
}

export const registerDevice = async (data: IRegisterDeviceRequestParams) => {
  return await client
    .request({
      url: `${PATH.DEVICE}/register`,
      method: 'POST',
      data,
      headers: getHeaders(),
    })
    .catch((err) => {
      console.log('err:', err.response)
      return err.response
    })
}

export const getDevice = async (deviceId: string) => {
  return await client
    .request({
      url: `${PATH.DEVICE}/${deviceId}`,
      method: 'GET',
      headers: getHeaders(),
    })
    .catch((err) => {
      console.log('err:', err.response)
      return err.response
    })
}

export const getCurrentStep = async (deviceId: string, data: object) => {
  return await client
    .request({
      url: `${PATH.DEVICE}/${deviceId}/step`,
      method: 'GET',
      data,
      headers: getHeaders(),
    })
    .catch((err) => {
      console.log('err:', err.response)
      return err.response
    })
}

export const getBackStep = async (deviceId: string, data: object) => {
  return await client
    .request({
      url: `${PATH.DEVICE}/${deviceId}/step/back`,
      method: 'GET',
      data,
      headers: getHeaders(),
    })
    .catch((err) => {
      console.log('err:', err.response)
      return err.response
    })
}

export const processCurrentStep = async (deviceId: string, data: object) => {
  return await client
    .request({
      url: `${PATH.DEVICE}/${deviceId}/step`,
      method: 'POST',
      data,
      headers: getHeaders(),
    })
    .catch((err) => {
      console.log('err:', err.response)
      return err.response
    })
}

export const addActivity = async (deviceId: string, data: object) => {
  return await client
    .request({
      url: `${PATH.DEVICE}/${deviceId}/activity`,
      method: 'POST',
      data,
      headers: getHeaders(),
    })
    .catch((err) => {
      console.log('err:', err.response)
      return err.response
    })
}

export const register = async (data: IRegisterRequestParams) => {
  return await client
    .request({
      url: `${PATH.AUTH}/register`,
      method: 'POST',
      data,
      headers: getHeaders(),
    })
    .catch((err) => {
      console.log('err:', err.response)
      return err.response
    })
}

export const validate = async (data: any) => {
  return await client
    .request({
      url: `${PATH.TOOLS}/validate`,
      method: 'POST',
      data,
      headers: getHeaders(),
    })
    .catch((err) => {
      console.log('err:', err.response)
      return err.response
    })
}

export const refreshToken = async () => {
  return await client
    .request({
      url: `${PATH.AUTH}/refreshtoken`,
      method: 'GET',
      headers: getHeadersRefreshToken(),
    })
    .catch((err) => {
      console.log('err:', err.response)
      return err.response
    })
}

export const login = async (data: ILoginRequestParams) => {
  return await client
    .request({
      url: `${PATH.AUTH}/local`,
      method: 'POST',
      data,
      headers: getHeaders(),
    })
    .catch((err) => {
      console.log('err:', err.response)
      return err.response
    })
}

export const forgot = async (params: IForgotRequestParams) => {
    return await client
        .request({
            url: `${PATH.AUTH}/sendpasswordreset`,
            method: 'GET',
            params,
            headers: getHeaders(),
        })
        .catch((err) => {
            console.log('err:', err.response)
            return err.response
        })
}
export const reset = async (data: IResetRequestParams) => {
    return await client
        .request({
            url: `${PATH.AUTH}/resetpassword`,
            method: 'POST',
            data,
            headers: getHeaders(),
        })
        .catch((err) => {
            console.log('err:', err.response)
            return err.response
        })
}
export const getDeviceId = () => {
  return sessionStorage.getItem('device') || ''
}
